import React, { useMemo } from "react";
import CustomTag from "./CustomTag";
import { CheckCircleFilled, CheckCircleOutlined, CloseCircleFilled, CloseCircleOutlined } from "@ant-design/icons";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import AlertTypeId from "src/consts/AlertTypeId";

interface OverCurrentLimitTagProps {
  binDto: PremierPlusBinDTO | null | undefined;
}

const OverCurrentLimitTag: React.FC<OverCurrentLimitTagProps> = ({ binDto }) => {
    const overCurrentTripped = useMemo(() => {
        return binDto?.activeAlerts?.some(
          a => a.alertTypeId === AlertTypeId.FanOverCurrent 
          || a.alertTypeId === AlertTypeId.MachineOverCurrent 
          || a.alertTypeId === AlertTypeId.AugerOverCurrent
        ) ?? false;
    }, [binDto]);

  return (
    <CustomTag
    label={overCurrentTripped ? "Over-current limit NOT OK" : "Over-current limit OK"}
    icon={overCurrentTripped ? <CloseCircleFilled /> : <CheckCircleFilled />} 
    color={overCurrentTripped ? "red" : "green"}
    />
  );
};

export default OverCurrentLimitTag;
